import { InvitationStatusType } from '@shared/enums/InvitationStatusType';
import { IEventModel } from '@shared/models/event.model';
import { IVenueModel } from '@shared/models/venue.model';
import { ActivityTimeRange, ActivityType, Application, IActivityLogBase } from '@shared/services/activity-service/activity.models';
import { ContactType } from '@shared/enums/ContactType';
import { CustomContactFieldType } from '@shared/enums/CustomContactFieldType';
import { FreeTextFormat } from '@shared/enums/FreeTextFormat';
import { IFieldTranslations } from '@shared/models/tag.model';
import { ContactActionType } from '@shared/enums/ContactActionType';
import { ContactActionByType } from '@shared/enums/ContactActionByType';
import { ConnectorType } from '@shared/enums/ConnectorType';


export interface IContactHistory {
    totalAttendees: number;
    checkedInAttendees: number;
    statusType: InvitationStatusType;
    event: IEventModel;
    locationDateTime: IVenueModel;
}

export interface IContactHistories {
    histories: IContactHistory[];
}

export interface IAddContact {
    ticketHolderId?: string;
    eventId?: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    title: string;
    genderId: string;
    languageId: string;
    email: string;
    phone: string;
    mobile: string;
    companyName: string;
    accountOwnerId: string;
    crmId: string;
    customerNumber: string;
    salutation: string;
    mailPermission: boolean;
    smsPermission: boolean;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    postalCode: string;
    country: string;
    type: ContactType;
    contactCustomFields?: IContactCustomField[];
    groupIds: string[];
    contactTags?: IContactTag[];
    unsubscribes?: IContactUnsubscribe[];
    logs?: IContactLog[];
}

export interface IContactLog {
    id: string;
    created: Date;
    unsubscribeOption: IContactUnsubscribeOption;
    user: IContactUnsubscribeUser;
    actionType: ContactActionType;
    actionByType: ContactActionByType;
    connectorType: ConnectorType;
}

export interface IContactUnsubscribeOption {
    id: string;
    name: string;
}

export interface IContactUnsubscribeUser {
    firstName: string;
    lastName: string;
    email: string;
}

export interface IContactCustomField {
    id: string;
    index: number;
    booleanValue: boolean;
    textValue: string;
    numberValue: number;
    dateTimeValue: Date;
    customFieldType: CustomContactFieldType;
    freeTextFormat: FreeTextFormat;
    translations: IFieldTranslations[];
    availableCustomFieldOptions: ICustomContactFieldOption[];
    contactCustomFieldOptions: ICustomContactFieldOption[];
    contactCustomFieldUsers: ICustomContactFieldUser[];
}

export interface ICustomContactFieldUser {
    userId: string;
}

export interface ICustomContactFieldOption {
    id: string;
    index: number;
    translations: IFieldTranslations[];
}

export interface IContactTag {
    id: string;
    index: number;
    translations: IFieldTranslations[];
}

export interface IContactUnsubscribe {
    unsubscribeDate: Date;
    unsubscribeOptionId: string;
}

export class ActivityFilter {
    constructor(public timeRange: ActivityTimeRange, public category: ActivityCategory = null, public userId: string = null, public contactId= null) { }
  }

export enum ActivityCategory {
    Created = 0,
    Updated = 1,
    Deleted = 2,
    Status = 3,
    Connector = 5,
    Export = 8
}

// for now contact activities hold no extra props other then the base props
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IActivityLog extends IActivityLogBase {
}
export interface IActivityLogs {
    activities: IActivityLog[];
}

export class AddContactAddressBook implements IAddContact {
    constructor(
        public id: string,
        public ticketHolderId: string,
        public firstName: string,
        public lastNamePrefix: string,
        public lastName: string,
        public title: string,
        public type: ContactType,
        public genderId: string,
        public languageId: string,
        public email: string,
        public phone: string,
        public mobile: string,
        public companyName: string,
        public salutation: string,
        public mailPermission: boolean,
        public smsPermission: boolean,
        public accountOwnerId: string,
        public addressLineOne: string,
        public addressLineTwo: string,
        public city: string,
        public postalCode: string,
        public country: string,
        public crmId: string,
        public customerNumber: string,
        public groupIds: string[],
        public contactCustomFields: IContactCustomField[],
        public contactTags: IContactTag[],
        public unsubscribes: IContactUnsubscribe[],
        public logs: IContactLog[],
        public companyId: string,
        public accessCode: string,
        public canEdit: boolean,
    ) { }
}
